import r from "mitt";
import { onMounted as u, onUnmounted as p } from "vue";
import { track as i } from "@ds/tracking/tracking";
const n = r();
let e = "", d = null;
const a = (o) => {
  i({
    action: "modal",
    context: { name: e, status: o }
  });
}, f = () => e !== "", O = (o) => o === e, M = (o = "", l = { cause: "custom" }) => {
  if (e !== "") {
    if (l.cause === "backdropClick" && l.disabled)
      return;
    a("closed"), (o !== "" && o === e || o === "") && (n.emit("close", { name: e, closingEvent: l }), e = "");
  }
}, k = (o, l) => {
  o !== e && f() && M(), e = o, d = l?.target, a("opened"), n.emit("open", e);
}, b = (o, l) => {
  const t = () => {
    e === o && l({ opened: !0 });
  }, s = ({ closingEvent: c }) => {
    e === o && l({ opened: !1, closingEvent: c }), d?.focus(), d = null;
  };
  u(() => {
    n.on("open", t), n.on("close", s);
  }), p(() => {
    n.off("open", t), n.off("close", s);
  });
};
export {
  M as closeModal,
  f as hasModalInPage,
  O as isModalOpened,
  k as openModal,
  b as useModalListener
};
